import {
  Button,
  CircularProgress,
  TextField,
  withStyles
} from '@material-ui/core';
import {
  ArrowForwardRounded,
  ArrowBackRounded,
  Dialpad
} from '@material-ui/icons';
import React, { Component } from 'react';
import combineStyles from '../../../helpers/combineStyles';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import {
  default as LoginPageStyles,
  default as styles
} from './LoginPage.styles';

class QrForm extends Component {
  state = {
    otp: '',
    isQrScanned: false
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  render() {
    const { classes, qrImageUrl, needVerification, login, email, password, loading, resetLoginInfo, resetForm } = this.props;
    const { isQrScanned, otp } = this.state;

    return (
      <div style={{ width: '80%' }}>
        <div
          className={classes.backContainer}
          onClick={() => {
            resetForm();
            resetLoginInfo();
          }}
        >
          <ArrowBackRounded
            style={{ position: 'relative', marginRight: '4px' }}
          />
          {' '}Regresar
        </div>
        {isQrScanned || (needVerification && !qrImageUrl) ? (
          <>
            <TextField
              variant="outlined"
              id="otp"
              label="Ingrese el código"
              name="otp"
              fullWidth
              className={classes.emailInput}
              InputProps={{
                startAdornment: <Dialpad color="action" />
              }}
              value={otp}
              onChange={this.handleChange}
            />
            <div className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                className={classes.loginButton}
                onClick={() => login(email, password, otp)}
                disabled={loading}
              >Enviar</Button>
              {loading && (
                <CircularProgress size={24} className={classes.buttonProgress} />
              )}
            </div>
          </>
        ) : (
          <>
            <h1 style={{ color: 'black', margin: 0 }}>
              Escanee el código QR
            </h1>
            <div style={{ display: 'flex', width: '80%', maxWidth: '528px', justifyContent: 'center' }}>
              <img src={qrImageUrl} />
            </div>
            <div className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                className={classes.loginButton}
                onClick={() => this.setState({ isQrScanned: true })}
              >
                Ya lo escaneé{' '}
                <ArrowForwardRounded
                  style={{ position: 'relative', left: '8px' }}
                />
              </Button>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default withStyles(
  combineStyles(styles, LoginPageStyles, ButtonStyles, TypographyStyles)
)(QrForm);
